// TODO: Remove from `core-js@4`
require('../modules/es.promise.all-settled.js');
